import { types } from 'mobx-state-tree';
import { QuestionWithSpots, Spot } from '../abstract-question-with-spots.store';

export const DragOut = QuestionWithSpots.named('DragOut').props({
  spots: types.array(Spot),
  questions: types.array(types.string),
});
